<div class="container py-4 py-md-5">
    <!-- Hero -->
    <div class="mb-4 mb-md-5 rounded-4"
             style="height:240px;background:url('assets/Images/carrousel/slide-03.jpg') center/cover;"></div>

    <h1 class="fw-bold mb-3">Servicios</h1>

    <div class="row">
        <div *ngFor="let item of items" class="col-12 col-md-6 col-lg-4 mb-4">
            <div class="catalog-card h-100 rounded-4 shadow-sm">
                <img *ngIf="item.coverFileId" class="card-img-top rounded-top-4"
                         [src]="fileBaseUrl + '/' + item.coverFileId"
                         onerror="this.src='assets/Images/No-image-found.jpg'; this.error=null;"
                         [alt]="item.title" loading="lazy">

                <div class="p-3 card-body-flex">
                    <div class="card-header-flex">
                        <h5 class="fw-bold">{{ item.title }}</h5>
                        <h6 class="subtitle text-secondary mb-2">{{ item.subtitle }}</h6>
                        <p class="text-muted mb-2">{{ item.shortDescription }}</p>
                    </div>

                    <div class="d-flex align-items-center justify-content-between mt-2 price-footer">
                        <div class="price fw-semibold">
                            <ng-container *ngIf="item.basePrice != null; else noPrice">
                                {{ item.basePrice | currency }}
                                <small *ngIf="item.appliesITBIS" class="text-muted">+ ITBIS</small>
                            </ng-container>
                            <ng-template #noPrice>
                                <span class="text-muted">—</span>
                            </ng-template>
                        </div>
                        <button class="btn btn-primary" (click)="navigateDetail(item)">
                            {{ item.preApprovalRequired ? 'Solicitar' : 'Comprar' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="text-center py-3" *ngIf="loading && items.length === 0">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
    </div>
</div>